import type { Configuration } from 'rollbar';
import { getEnvironment } from '../core/utilities/getEnvironment';

const code_version = document.querySelector('meta[name="app-version"]')?.getAttribute('content') ?? 'unknown';

export const rollbarConfig: Configuration = {
  accessToken: '21a0ac7f50864f01911930797c84c5205946af0d7e48bbbee14c3892d39639ba6085ba6fe822ce0cfd0269f101d35187',
  captureUncaught: true,
  captureUnhandledRejections: true,
  payload: {
    environment: getEnvironment().type,
    client: {
      javascript: {
        source_map_enabled: true, // false by default

        // -- Add this into your configuration ---
        code_version,
        // ---------------------------------------

        // Optionally have Rollbar guess which frames the error was
        // thrown from when the browser does not provide line
        // and column numbers.
        guess_uncaught_frames: true,
      },
    },
  },
  addErrorContext: true,
  enabled: import.meta.env.MODE !== 'development',
};
